<template>
  <div v-if="self.isShow" class="h5-select-store column">
    <div class="store-title">请选择门店</div>

    <div class="store-list flex-1 overflow-y">
      <div
        class="store-item row flex-center"
        :class="{ active: row.id == self.current }"
        v-for="row in clinicList"
        :key="row.id"
        @click="handleSelectStore(row)"
      >
        <div class="store-info flex-1">
          <div class="clinic-name">{{ row.clinicName || "" }}</div>
          <div class="clinic-abbreviation">
            简称：{{ row.abbreviation || "" }}
          </div>
        </div>
        <!-- <div
          class="iconfont icon-ok select-icon"
          :class="{ active: row.id == self.current }"
        ></div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "H5SelectStore",
  props: {
    self: {
      type: Object,
      required: false,
      default: () => ({
        isShow: false,
        current: "",
      }),
    },
    clinicList: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  emits: ["storeChange"],
  methods: {
    handleSelectStore(row) {
      const clinicId = row?.id || "";

      if (!clinicId) {
        return;
      }

      // 先记录当前选择，父组件切换门店成功后再关闭弹层
      this.self.current = clinicId;
      this.$emit("storeChange", row);
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes rightin {
  from {
    transform: translateX(100%);
  }

  to {
    transform: translateX(0);
  }
}

.h5-select-store {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #f6f6f6;
  animation: rightin 0.3s forwards;
  -webkit-animation: rightin 0.3s forwards;
}

.store-title {
  flex-shrink: 0;
  padding: .292rem .333rem;
  background-color: #fff;
  color: #333;
  font-size: .333rem;
  text-align: left;
}

.store-list {
  height: 0;
  margin-top: .167rem;
  padding: 0 .292rem .334rem;
  background-color: #fff;
}

.store-item {
  padding: .292rem .125rem;
  border-bottom: .021rem solid #eee;
  color: #333;
  text-align: left;

  &.active {
    color: #28b8c3;
  }
}

.store-info {
  min-width: 0;
}

.clinic-name {
  overflow: hidden;
  font-size: .292rem;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.clinic-abbreviation {
  margin-top: .083rem;
  overflow: hidden;
  color: #999;
  font-size: .292rem;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.select-icon {
  flex-shrink: 0;
  margin-left: .208rem;
  color: #ccc;
  font-size: .333rem;

  &.active {
    color: #28b8c3;
  }
}
</style>
